import React, {Component} from "react";
import {Dropdown, DropdownItem, DropdownMenu, DropdownToggle} from "reactstrap";
import {Link, withRouter} from "react-router-dom";

class WalletMenu extends Component {

    constructor(props) {
        super(props);
        this.state = {
            menu: false
        };
        this.toggle = this.toggle.bind(this);
    }

    toggle() {
        this.setState(prevState => ({
            menu: !prevState.menu
        }));
    }

    render() {

        return (
            <React.Fragment>
                <Dropdown isOpen={this.state.menu} toggle={this.toggle} className="d-inline-block">
                    <DropdownToggle className="btn header-item waves-effect" id="page-header-user-dropdown"
                                    tag="button">
                        <i className="bx bx-wallet header-profile-user-text font-size-22"/>
                        <span className="d-none d-xl-inline-block ml-2 mr-1">Wallet</span>
                        <i className="mdi mdi-chevron-down d-none d-xl-inline-block"/>
                    </DropdownToggle>
                    <DropdownMenu right>
                        <DropdownItem tag={Link} to="/transfer#deposit"><i
                            className="bx bx-download font-size-16 align-middle mr-1"/>Deposit
                        </DropdownItem>
                        <DropdownItem tag={Link} to="/transfer#withdraw"><i
                            className="bx bx-upload font-size-16 align-middle mr-1"/>Withdraw
                        </DropdownItem>
                        <DropdownItem tag={Link} to="/balances"><i
                            className="bx bx-wallet font-size-16 align-middle mr-1"/>Balances
                        </DropdownItem>
                        {/*<DropdownItem tag={Link} to="/dashboard"><i*/}
                        {/*    className="bx bx-bar-chart-alt-2 font-size-16 align-middle mr-1"/>Reports*/}
                        {/*</DropdownItem>*/}
                    </DropdownMenu>
                </Dropdown>
            </React.Fragment>
        );
    }
}

export default withRouter(WalletMenu);
